<h2 mat-dialog-title>
  <mat-icon class="title-icon">account_tree</mat-icon>
  {{ titleKey | translate }}
</h2>
<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content class="dialog-container">
    <div class="app-container">
      @if (data.mode === 'fromProject') {
        <mat-form-field appearance="fill">
          <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.PROJECT' | translate }}</mat-label>
          <mat-icon matPrefix>content_copy</mat-icon>
          <mat-select formControlName="projectId">
            @for (project of projects$ | async; track project.id) {
              <mat-option [value]="project.id" (onSelectionChange)="$event.isUserInput && onProjectChange(project.id, project.name)">
                {{ project.costCenterNumber }} - {{ project.name }}
              </mat-option>
            }
          </mat-select>
          <mat-hint>{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.PROJECT_HINT' | translate }}</mat-hint>
        </mat-form-field>

        @if (previewLoading()) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        } @else if (form.controls.projectId.value && previewNodes().length === 0) {
          <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.ERROR.SOURCE_TREE_EMPTY' | translate }}</p>
        } @else if (previewNodes().length > 0) {
          <app-classification-preview [nodes]="previewNodes()"></app-classification-preview>
        }
      }

      <mat-form-field appearance="fill">
        <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.NAME' | translate }}</mat-label>
        <input matInput formControlName="name" maxlength="200" required />
        @if (form.controls.name.hasError('nameExists')) {
          <mat-error>{{ 'WORKCLASSIFICATION.TEMPLATES.ERROR.NAME_EXISTS' | translate }}</mat-error>
        } @else if (form.controls.name.hasError('required')) {
          <mat-error>{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.REQUIRED' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.DESCRIPTION' | translate }}</mat-label>
        <textarea matInput formControlName="description" rows="3"></textarea>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.BUSINESS_AREA_HINT' | translate }}</mat-label>
        <mat-select formControlName="businessAreaHint">
          <mat-option [value]="null">{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.NO_AREA' | translate }}</mat-option>
          @for (area of areas; track area) {
            <mat-option [value]="area">{{ area }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" class="btn-secondary" mat-dialog-close>{{ 'COMMON.CANCEL' | translate }}</button>
    <button mat-raised-button type="submit" class="btn-primary" [disabled]="saving()">
      {{ (data.mode === 'edit' ? 'COMMON.SAVE' : 'WORKCLASSIFICATION.TEMPLATES.FORM.CREATE') | translate }}
    </button>
  </mat-dialog-actions>
</form>
